import { HighlightedCourse } from '@/client/courses';
import { HighlightedCourseCard } from '@/components/courses/HighlightedCourseCard';
import { FlexContainer } from '@/ui/styled-ui';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const MAX_HIGHLIGHTED_COURSES = 4;

const StyledHeading = styled.h2`
  font-size: var(--semi-big-font-size);
  line-height: var(--semi-big-line-height);
  font-weight: 600;
`;

const StyledRow = styled(FlexContainer)`
  margin-bottom: var(--big-padding);
`;

type HighlightedCoursesRowProps = {
  courses?: HighlightedCourse[];
  onCourseSelect: (courseId: string) => void;
};

export const HighlightedCoursesRow: React.FC<HighlightedCoursesRowProps> = ({
  courses,
  onCourseSelect,
}) => {
  const { t } = useTranslation();

  if (!courses?.length) return null;

  return (
    <>
      <StyledHeading>{t('courses.highlighted')}</StyledHeading>
      <StyledRow
        direction="row"
        align="initial"
        justify="flex-start"
        gap={14}
        width="100%"
        className="highlighted-content"
      >
        {courses.slice(0, MAX_HIGHLIGHTED_COURSES).map((course, index) => (
          <HighlightedCourseCard
            key={course.id}
            id={course.id}
            course={course}
            index={index}
            onClick={() => onCourseSelect(course.id)}
          />
        ))}
      </StyledRow>
    </>
  );
};
